import { render, staticRenderFns } from "./twoTest.vue?vue&type=template&id=8e01229a&scoped=true"
import script from "./twoTest.vue?vue&type=script&lang=js"
export * from "./twoTest.vue?vue&type=script&lang=js"
import style0 from "./twoTest.vue?vue&type=style&index=0&id=8e01229a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e01229a",
  null
  
)

export default component.exports